import { formatCurrency } from "../date-utils";
export const activityTypeDtoFields = [{
        name: "numCode",
        title: "Codice",
        render: (record) => record.activityType.numCode
    }, {
        name: "activityCategoryDescription",
        title: "Categoria",
        render: (record) => record.activityCategoryDescription
    }, {
        name: "description",
        title: "Descrizione",
        render: (record) => record.activityType.description
    }, {
        name: "hourlyRevenue",
        title: "Costo Orario",
        render: (record) => formatCurrency(record.activityType.hourlyRevenue)
    }];
